module.exports = __webpack_public_path__ + "components/guide-page/static/wave-background-09323fb80614124eb92c9636e8392c03.svg";